// extracted by mini-css-extract-plugin
export default {"root":"QbMzVk","icon":"vViQ0X","rootComp":"s8mQgd"};